import { ArrowRight, PhoneCall, ShieldCheck, Anchor, Wrench } from "lucide-react";

/* import heroVideo from "@/assets/hero-Vi.mp4"; */
import heroVideo from "@/assets/hero-Vi.mp4";
export function Hero() {
  return (
    <section id="home" className="relative isolate min-h-[100svh] overflow-hidden">
      <video
        src={heroVideo}
        autoPlay
        muted
        loop
        playsInline
        width={1920}
        height={1080}
        className="absolute inset-0 -z-20 h-full w-full object-fill"
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-navy-deep/95 via-navy-deep/80 to-ocean/70" />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,oklch(0.72_0.18_50/0.15),transparent_55%)]" />

      <div className="container-x relative flex min-h-[100svh] flex-col justify-center pt-32 pb-20">
        <div className="max-w-3xl animate-float-up">
          <span className="eyebrow">Global Inspection & Engineering</span>
          <h1 className="mt-6 text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl">
            Building Trust Through <span className="text-orange">Transparency.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/80 sm:text-xl">
            Inspection, Certification, Maintenance, Training and Engineering Solutions for Onshore
            and Offshore Industries.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 rounded-md bg-orange px-7 py-4 text-base font-semibold text-white shadow-xl transition-all hover:bg-orange-hover hover:translate-y-[-2px]"
            >
              Request Service <ArrowRight className="h-5 w-5" />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 rounded-md border border-white/30 bg-white/5 px-7 py-4 text-base font-semibold text-white backdrop-blur transition-all hover:bg-white/15"
            >
              <PhoneCall className="h-5 w-5" /> Contact Us
            </a>
          </div>
        </div>

        <div className="mt-16 grid max-w-4xl grid-cols-1 gap-px overflow-hidden rounded-xl border border-white/10 bg-white/5 backdrop-blur sm:grid-cols-3">
          {[
            { icon: ShieldCheck, label: "ISO Certified", sub: "International Standards" },
            { icon: Anchor, label: "Offshore Expertise", sub: "Marine & Energy Sector" },
            { icon: Wrench, label: "24/7 Field Support", sub: "Onshore & Offshore" },
          ].map(({ icon: Icon, label, sub }) => (
            <div key={label} className="flex items-center gap-4 bg-navy-deep/40 px-6 py-5">
              <Icon className="h-8 w-8 shrink-0 text-orange" />
              <div className="min-w-0">
                <div className="truncate text-sm font-semibold text-white">{label}</div>
                <div className="truncate text-xs text-white/60">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
}
